import { fetchService } from "./fetchService";
import * as API_PATHS from "utility/api-paths";
import { TeamSection } from "pages/team-directory/types";

export const fetchTeamDirectoryConfig = async (): Promise<TeamSection[]> => {
  try {
    return await fetchService<TeamSection[]>(API_PATHS.GET_TEAM_DIRECTORY_CONFIG, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    throw new Error(
      error instanceof Error ? error.message : "An unknown error occurred."
    );
  }
};
